module.exports = __webpack_public_path__ + "img/ct_bru-profile.2600f78e.png";